import React from 'react';
import type PolarisUnlicensedPageType from '@atlassian/jira-spa-apps-polaris-unlicensed/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// This will be migrated with the other JPD pages.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyUnlicensedPage = lazyForPaint<typeof PolarisUnlicensedPageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-polaris-unlicensed", jiraSpaEntry: "async-polaris-ideas" */ '@atlassian/jira-spa-apps-polaris-unlicensed'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyUnlicensedPage} pageId="async-polaris-unlicensed" shouldShowSpinner={false} />
);
